let cachedSearch = ''
let cachedParams: Record<string, string> = {}

/**
 * Retorna todos os query parameters da URL como um objeto tipado.
 * Lê diretamente de window.location.search (sem dependência do Next.js Router).
 *
 * Memoizado: só re-parseia quando window.location.search muda.
 * SSR-safe: retorna objeto vazio no server.
 */
export function getWebviewQuery<T extends Record<string, string> = Record<string, string>>(): Partial<T> {
  if (typeof window === 'undefined') return {} as Partial<T>

  const currentSearch = window.location.search

  if (currentSearch === cachedSearch) {
    return cachedParams as Partial<T>
  }

  cachedSearch = currentSearch

  if (!currentSearch) {
    cachedParams = {}
    return cachedParams as Partial<T>
  }

  const params = new URLSearchParams(currentSearch)
  const result: Record<string, string> = {}
  params.forEach((value, key) => {
    result[key] = value
  })
  cachedParams = result

  return cachedParams as Partial<T>
}

/**
 * Retorna o valor de um único query parameter.
 * Retorna undefined se o key não existir.
 */
export function getWebviewQueryParam(key: string): string | undefined {
  return getWebviewQuery()[key]
}

/**
 * Limpa o cache interno (útil para testes).
 */
export function clearWebviewQueryCache(): void {
  cachedSearch = ''
  cachedParams = {}
}
